<template>
  <div class="row">
    <div class="col">
      <button class="btn btn-secondary btn-sm mb-2" type="button" @click="$window.location.reload()" title="Osveži">
        ⟳ Osveži
      </button>
    </div>
  </div>

  <HomeAdmin class="row mt-3" v-if="role === 'Administrator'" />
  <HomeLeaderService class="row mt-3" v-else-if="role === 'LeaderService'" />
  <HomeLeaderProduction class="row mt-3" v-else-if="role === 'LeaderProduction'" />
  <HomeLeaderProjects class="row mt-3" v-else-if="role === 'LeaderProjects'" />
  <HomeWorkerService class="row mt-3" v-else-if="$hasRole(role, ['WorkerService', 'WorkerSubcontractor'])" />
  <HomeWorkerProduction class="row mt-3" v-else-if="role === 'WorkerProduction'" />
  <HomeWorkerProjects class="row mt-3" v-else-if="role === 'WorkerProjects'" />
  <HomeWarehouseManager class="row mt-3" v-else-if="role === 'WarehouseManager'" />

  <div v-else-if="role === 'Customer'"><h2>Pozdravljeni {{ user?.name }}!</h2></div>
  <div class="row mt-3" v-else>
    <h1>Vsebina strani domov ni definirana za vrsto uporabnika: {{ role }}.</h1>
  </div>

  <div class="row d-print-none" v-if="$window.CONTEXT === 'stage'">
    <div class="d-block d-sm-none">xs</div>
    <div class="d-none d-sm-block d-md-none">sm</div>
    <div class="d-none d-md-block d-lg-none">md</div>
    <div class="d-none d-lg-block d-xl-none">lg</div>
    <div class="d-none d-xl-block">xl</div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { setError, startLoading, stopLoading } from "../components/Notification"
import { useAuth, authState, isAuthenticated, user, role } from "../composition-api/useAuth"
import SelectWarehouse from "../components/SelectWarehouse.vue"
import Notifications from "../components/Notifications.vue"

import HomeAdmin from "./HomeAdmin.vue"
import HomeLeaderService from "./HomeLeaderService.vue"
import HomeLeaderProduction from "./HomeLeaderProduction.vue"
import HomeLeaderProjects from "./HomeLeaderProjects.vue"
import HomeWorkerService from "./HomeWorkerService.vue"
import HomeWorkerProduction from "./HomeWorkerProduction.vue"
import HomeWorkerProjects from "./HomeWorkerProjects.vue"
import HomeWarehouseManager from "./HomeWarehouseManager.vue"

defineOptions({ name: "Home" })


</script>
